import React, { Component } from 'react';
import { Table, Row, Col, InputNumber, Button, DatePicker, message, Spin, Input } from 'antd';
import moment from 'moment';
import { data7_1_2 } from './data';
import imgSave from "../../saveImg";
import Auth from "../../Auth";
import Compared from "../../Compared";

const { MonthPicker } = DatePicker;
const { TextArea } = Input;

Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            loading: true,
            note: {
                note: ""
            },
            loadingSave: false,
            print: false
        }
    }


    componentDidMount() {
        this.getDateData(this.state.date);
        // this.computeNum(this.state.data)
    }



    computeNum = (data) => {
        const numConvert = (num = 0) => {
            num = Number(num || "0")
            return num
        };

        const totalName = ['this_Actual', 'last_Actual', 'year_this_Actual', 'year_last_Actual'];

        for (let i = 0; i < totalName.length; i++) {
            data[12][totalName[i]] = data.reduce((a, b) => {
                if (b.name != 'Total') {
                    a += numConvert(b[totalName[i]]);
                }
                return a
            }, 0);
            data[12][totalName[i]] = data[12][totalName[i]].toFixed(0);
        }

        for (let i = 0; i < data.length; i++) {
            data[i].contrast = (numConvert(data[i].this_Actual) - numConvert(data[i].last_Actual)).toFixed(0);
            data[i].percent = (numConvert(data[i].last_Actual) == 0 ? 0 : (numConvert(data[i].contrast) / numConvert(data[i].last_Actual))).toFixed(3);
            data[i].year_contrast = (numConvert(data[i].year_this_Actual) - numConvert(data[i].year_last_Actual)).toFixed(0);
            data[i].year_percent = (numConvert(data[i].year_last_Actual) == 0 ? 0 : (numConvert(data[i].year_contrast) / numConvert(data[i].year_last_Actual))).toFixed(3);
        }

        this.setState({
            data
        });

    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        // this.setState({
        //     data
        // });
        this.computeNum(data);
    }

    getDateData = (date) => {
        const dataBegin = JSON.stringify(data7_1_2);
        let data = JSON.parse(dataBegin);
        this.getNote(date);
        fetch(`/_9_7_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data && x.data.length > 0) {
                data = x.data;
            }
            this.setState({ loading: false });
            this.computeNum(data);
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    getNote = (date) => {
        fetch(`/_9_7_1_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data && x.data.length > 0) {
                this.setState({
                    note: { ...x.data[0] }
                });
            }
        }).catch(err => {
            console.error(err);
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data.map(x => ({ ...x, year, month }));
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        if (this.state.note) {
            this.onSaveNote([{ ...this.state.note, year, month }])
        }
        fetch('/add_9_7', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getDateData(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            message.error('保存失败' + JSON.stringify(err));
            console.error(err);
        })
    }

    onSaveNote = (data) => {
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_9_7_1', headres).then(x => x.json()).then(x => {
            if (x.status == 1) {
                // message.success(x.msg);
                return
            }
            message.error('备注保存失败：' + x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table9_7', 1.5, '9.70', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }

    render() {
        const data = this.state.data;
        const columns = [{
            title: 'Expenses Item 费用项目',
            dataIndex: 'name',
            key: 'name',
            align: "center",
            width: 250,
            render: (text, record, index) => {
                return (
                    <div className={`table-padding ${index == 12 ? 'table-color-footer' : ''}`} style={{ textAlign: "left" }}>
                        {text}
                    </div>
                )
            }
        }, {
            align: "center",
            title: 'Current Month 月累计',
            children: [{
                title: <div>Current Month Actual<br /> This Year <br />本年当月实际数</div>,
                dataIndex: 'this_Actual',
                key: 'this_Actual',
                align: "center",
                width: 100,
                render: (text, record, index) => {
                    const title = ['Current Month 月累计', 'Current Month Actual This Year 本年当月实际数'];
                    if (index <= 11) {
                        return (
                            <Compared data={{ index, key: 'this_Actual', title, sqlName: "_9_7", name: record.name, type: 'number' }}>
                                <div className="table-padding table-color-number">
                                    <InputNumber
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                        precision={0}
                                        className="table_numInput"
                                        defaultValue={text == 0 ? '' : text}
                                        onBlur={(e) => {
                                            let value = Number(e.target.value.replace(/,/g, '') || '0');
                                            value = Number(value.toFixed(0));
                                            this.onChange('this_Actual', value, index)
                                        }}

                                    />
                                </div>
                            </Compared>
                        )
                    } else {
                        return (
                            <Compared data={{ index, key: 'this_Actual', title, sqlName: "_9_7", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${index == 12 ? 'table-color-footer' : ''}`}>
                                    {text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }
            }, {
                title: <div>Current Month Actual<br /> Last Year <br />去年当月实际数</div>,
                dataIndex: 'last_Actual',
                key: 'last_Actual',
                align: "center",
                width: 100,
                render: (text, record, index) => {
                    const title = ['Current Month 月累计', 'Current Month Actual Last Year 去年当月实际数'];
                    if (index <= 11) {
                        return (
                            <Compared data={{ index, key: 'last_Actual', title, sqlName: "_9_7", name: record.name, type: 'number' }}>
                                <div className="table-padding table-color-number">
                                    <InputNumber
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                        precision={0}
                                        className="table_numInput"
                                        defaultValue={text == 0 ? '' : text}
                                        onBlur={(e) => {
                                            let value = Number(e.target.value.replace(/,/g, '') || '0');
                                            value = Number(value.toFixed(0));
                                            this.onChange('last_Actual', value, index)
                                        }}

                                    />
                                </div>
                            </Compared>
                        )
                    } else {
                        return (
                            <Compared data={{ index, key: 'last_Actual', title, sqlName: "_9_7", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${index == 12 ? 'table-color-footer' : ''}`}>
                                    {text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }
            }, {
                title: <div>Current Month Variance<br />This Year vs. Last Year<br /> 当月差异-今年对比去年</div>,
                dataIndex: 'contrast',
                key: 'contrast',
                align: "center",
                width: 100,
                render: (text, record, index) => {
                    const title = ['Current Month 月累计', 'Current Month Variance This Year vs. Last Year 当月差异-今年对比去年'];
                    return (
                        <Compared data={{ index, key: 'contrast', title, sqlName: "_9_7", name: record.name, type: 'number' }}>
                            <div className={`table-padding ${index == 12 ? 'table-color-footer' : ''}`} >
                                {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            </div>
                        </Compared>
                    )
                }
            }, {
                title: '% 百分比',
                dataIndex: 'percent',
                key: 'percent',
                align: "center",
                width: 100,
                render: (text, record, index) => {
                    const title = ['Current Month 月累计', '% 百分比'];
                    return (
                        <Compared data={{ index, key: 'percent', title, sqlName: "_9_7", name: record.name, type: 'percent' }}>
                            <div className={`table-padding ${index == 12 ? 'table-color-footer' : ''}`} >
                                {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                            </div>
                        </Compared>
                    )
                }
            }]
        }, {
            align: "center",
            title: 'YTD 年累计',
            children: [{
                title: <div>YTD Actual <br />This Year<br />年累计实际-今年</div>,
                dataIndex: 'year_this_Actual',
                key: 'year_this_Actual',
                align: "center",
                width: 100,
                render: (text, record, index) => {
                    const title = ['YTD 年累计', 'YTD Actual This Year 年累计实际-今年'];
                    if (index <= 11) {
                        return (
                            <Compared data={{ index, key: 'year_this_Actual', title, sqlName: "_9_7", name: record.name, type: 'number' }}>
                                <div className="table-padding table-color-number">
                                    <InputNumber
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                        precision={0}
                                        className="table_numInput"
                                        defaultValue={text == 0 ? '' : text}
                                        onBlur={(e) => {
                                            let value = Number(e.target.value.replace(/,/g, '') || '0');
                                            value = Number(value.toFixed(0));
                                            this.onChange('year_this_Actual', value, index)
                                        }}

                                    />
                                </div>
                            </Compared>
                        )
                    } else {
                        return (
                            <Compared data={{ index, key: 'year_this_Actual', title, sqlName: "_9_7", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${index == 12 ? 'table-color-footer' : ''}`} >
                                    {text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }

                }
            }, {
                title: <div>YTD Actual <br /> Last Year<br />年累计实际-去年</div>,
                dataIndex: 'year_last_Actual',
                key: 'year_last_Actual',
                align: "center",
                width: 100,
                render: (text, record, index) => {
                    const title = ['YTD 年累计', 'YTD Actual Last Year 年累计实际-去年'];
                    if (index <= 11) {
                        return (
                            <Compared data={{ index, key: 'year_last_Actual', title, sqlName: "_9_7", name: record.name, type: 'number' }}>
                                <div className="table-padding table-color-number">
                                    <InputNumber
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                        precision={0}
                                        className="table_numInput"
                                        defaultValue={text == 0 ? '' : text}
                                        onBlur={(e) => {
                                            let value = Number(e.target.value.replace(/,/g, '') || '0');
                                            value = Number(value.toFixed(0));
                                            this.onChange('year_last_Actual', value, index)
                                        }}

                                    />
                                </div>
                            </Compared>
                        )
                    } else {
                        return (
                            <Compared data={{ index, key: 'year_last_Actual', title, sqlName: "_9_7", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${index == 12 ? 'table-color-footer' : ''}`}>
                                    {text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }
            }, {
                title: <div>YTD Variance<br />This Year vs. Last Year<br />年累计差异-今年对比去年</div>,
                dataIndex: 'year_contrast',
                key: 'year_contrast',
                align: "center",
                width: 100,
                render: (text, record, index) => {
                    const title = ['YTD 年累计', 'YTD Variance This Year vs. Last Year 年累计差异-今年对比去年'];
                    return (
                        <Compared data={{ index, key: 'year_contrast', title, sqlName: "_9_7", name: record.name, type: 'number' }}>
                            <div className={`table-padding ${index == 12 ? 'table-color-footer' : ''}`} >
                                {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            </div>
                        </Compared>
                    )
                }
            }, {
                title: '% 百分比',
                dataIndex: 'year_percent',
                key: 'year_percent',
                align: "center",
                width: 100,
                render: (text, record, index) => {
                    const title = ['YTD 年累计', '% 百分比'];
                    return (
                        <Compared data={{ index, key: 'year_percent', title, sqlName: "_9_7", name: record.name, type: 'percent' }}>
                            <div className={`table-padding ${index == 12 ? 'table-color-footer' : ''}`} >
                                {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                            </div>
                        </Compared>
                    )
                }
            }]
        }];

        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1">
                    <Row className="title" id="table9_7" style={{ width: this.state.print ? 1850 : 'auto' }}>
                        <Row>9.7 Department Expenses 部门费用</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true,
                                        note: { note: "" }
                                    });
                                    this.getDateData(str)
                                }}
                            />
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            bordered
                            pagination={false}
                            style={{ width: this.state.print ? 1800 : 'auto' }}
                            scroll={this.state.print ? {} : { x: 1800 }}
                            className="content"
                            rowKey={(record, index) => index}
                        />
                        <Row style={{ margin: "20px 0", }}>
                            <Row style={{ margin: "10px 0" }}>9.7.1  Please critique if variance above +/- 5% 若差异数超过上下百分之五则需做出书面解释</Row>
                            {!this.state.loading || this.state.print ? <TextArea
                                autosize={{ minRows: 4 }}
                                placeholder="请输入备注！"
                                defaultValue={this.state.note.note}
                                onBlur={(e) => {
                                    this.setState({
                                        note: { ...this.state.note, note: e.target.value }
                                    });
                                }}
                            /> : null}
                        </Row>
                    </Row>
                    <Auth loading={this.state.loading} auth="edit_9_7">
                        <Row className="table-footer-btn">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入pdf</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Row>
                    </Auth>

                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/9.0/9-7/index.js